import { render, staticRenderFns } from "./ForgetPasswordPage.vue?vue&type=template&id=acb9aa06"
import script from "./ForgetPasswordPage.vue?vue&type=script&lang=js"
export * from "./ForgetPasswordPage.vue?vue&type=script&lang=js"
import style0 from "./ForgetPasswordPage.vue?vue&type=style&index=0&id=acb9aa06&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports